import {CardsSliderContainer, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const CardsSliderLoading: React.FC = () => {
  return (
    <CardsSliderContainer>
      <SkeletonBlock $width="100%" $height="100%" />
    </CardsSliderContainer>
  );
};
